// extracted by mini-css-extract-plugin
module.exports = {"markAsRead":"NotificationContent_markAsRead__1rU0g"};